import React, { useEffect, useRef } from "react";

// UseEffect that only runs after first mount
export const useDidMountEffect = (
  func: { (): void; (): void },
  deps: React.DependencyList | undefined
) => {
  const didMount = useRef(false);
  useEffect(() => {
    if (didMount.current) return func();
    else didMount.current = true;
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};
